const EmptyState = ({ title, description, action }) => (
  <div className="empty-state">
    <p className="empty-state__title">{title}</p>
    {description ? <p className="empty-state__description">{description}</p> : null}
    {action}
  </div>
);

export default EmptyState;
